import React, { useState } from 'react';
import { universityLogoSrc } from '../utils/universityLogo.js';

function logoFallbackLabel(name) {
  const text = String(name || '').trim();
  if (!text) return 'U';
  const words = text.split(/\s+/).filter(Boolean);
  if (words.length === 1) {
    return words[0].slice(0, 3).toUpperCase();
  }
  return words
    .slice(0, 3)
    .map((word) => word[0])
    .join('')
    .toUpperCase();
}

export default function UniversityLogo({
  slug,
  name,
  logoUrl,
  className = 'university-logo'
}) {
  const src = universityLogoSrc(slug, logoUrl);
  const [failed, setFailed] = useState(false);

  if (!src || failed) {
    return (
      <span className={`${className} university-logo-fallback`} title={name} aria-hidden>
        {logoFallbackLabel(name)}
      </span>
    );
  }

  return (
    <img
      className={className}
      src={src}
      alt={`${name || 'University'} logo`}
      title={name}
      width="148"
      height="64"
      onError={() => setFailed(true)}
    />
  );
}
